import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { XnFormComponent, XnFormField, convertArrayFieldsToColumns } from '../../ui-components/xn-form/xn-form/xn-form.component';
import { BtrBookingService } from '../../core/services/btr-booking.service';
import { BookingInspectionData } from '../../apartment-search-result/apartment-search-result-page/apartment-search-result-page.component';
import { BookingInspectSave, SearchAvailabilityQuery } from '../../core/models/booking-model';
import { ActivatedRoute } from '@angular/router';
import { from, Subject, takeUntil } from 'rxjs';
import { UiService } from '../../core/ui.service';
import { ApiReadHotelContactInformationRS, BtrProfileAndContactDetail, CountryGroupItem, ReadRentalItemTypeRateAvailabilityRQ, RoomTypeConfig, TimeSlot, TimeSlotConfigure, TimeSlotDates, systemTypesByActivityTypeModel } from '../../core/api/api.models';
import { format_date, local_to_utc } from '../../utilities/date-utils';
import { IAppConfig } from '../../core/config/app-config.model';
import { APP_CONFIG } from '../../core/config/app-config.service';
import { AuthService } from '../../core/api/auth.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '../../core/log.service';
import { GgEventAction, GgEventName } from '../../auth/login-form/login-form.component';
import { Calendar } from '../../ui-components/calendar/calendar/calendar';

interface BookingInspectForm {
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: string,
  phoneNumberDialCode?: string,
  budgetAmount?: string,
  siteTourType?: string,
  furnished?: string,
  isHavePet?: boolean,
  isParking?: boolean,
  remark?: string,
  stayWith?: string,
  preferedMoveInDate?: string | Date,
  minBedrooms: string
}
@Component({
  selector: 'app-book-an-inspection',
  standalone: false,
  templateUrl: './book-an-inspection.component.html',
  styleUrls: ['./book-an-inspection.component.sass']
})
export class BookAnInspectionComponent implements OnInit {

  currentDate: Date = new Date();

  currentStep: 'selectTime' | 'fillData' = 'selectTime';

  currentHotelCode: string = '';

  timeSlotConfigure?: TimeSlotConfigure
  timeSlotConfigures?: TimeSlotConfigure[]

  disableDate: Date[] = []

  availableTime: TimeSlot[] = []

  profileContactDetail?: BtrProfileAndContactDetail

  @ViewChild('calendar') calendar?: Calendar;
  @ViewChild('systemTypeForm') systemTypeForm?: XnFormComponent


  constructor(
    private btrBookingService: BtrBookingService,
    private route: ActivatedRoute,
    private ui: UiService,
    private auth: AuthService,
    private translate: TranslateService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    @Inject(APP_CONFIG) protected config: IAppConfig,
    private log: LogService,
  ) {

  }

  fields: XnFormField[] = [];

  whoMovingInType: { value: string; translate?: string | undefined; }[] = []

  @ViewChild('inspectForm') inspectForm: XnFormComponent | undefined;
  @Output('onSubmit') onSubmit = new EventEmitter();
  @Input('bookingInspectionData') bookingInspectionData?: BookingInspectionData;
  @Input('hotelOptions') hotelOptions?: CountryGroupItem[] = [];;
  @Input('isNeedInspectionData') isNeedInspectionData?: boolean = true;
  @Input('roomTypeConfig') roomTypeConfig?: RoomTypeConfig;
  @Input() visible: boolean = false
  @Output('visibleChange') visibleChange = new EventEmitter<boolean>();
  searchAvailabilityQuery: SearchAvailabilityQuery | undefined | null;
  destroyed = new Subject();

  isSubmitted = false;

  allowEditProfile: boolean = true;

  data: BookingInspectSave = {
    siteTourBookingID: '',
    systemType: '',
    propertyCode: '',
    hotelRoomTypeID: 0,
    hotelRoomID: 0,
    visitDate: '',
    timeSelect: undefined,
    timeSlotConfigure: undefined,
    stayWith: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    phoneExt: '',
    budgetType: 'Weekly',
    budgetAmount: '',
    location: '',
    isKeepUpdate: false,
    furniture: '',
    siteTourType: 'OnSite',
    pet: false,
    parking: false,
    remark: '',
    preferedMoveInDate: '',
    minBedrooms: ''
  }

  selectDate?: Date | null

  currentMonthYear: { month: number, year: number } = { month: 0, year: 0 }

  systemTypes: systemTypesByActivityTypeModel[] = []

  systemTypeDescription: string = '';

  ngOnInit(): void {
    this.currentMonthYear = { month: new Date().getMonth() + 1, year: new Date().getFullYear() }
    this.whoMovingInType = this.btrBookingService.getWhoMovingInData();
    this.route.queryParams.pipe(takeUntil(this.destroyed)).subscribe((params: any) => {
      this.loadSearchAvailabilityQuery(params);
      this.currentStep = 'selectTime';
    });
  }

  systemFields: XnFormField[] = [{
    name: 'hotelCode',
    label: 'Location',
    type: 'select',
    placeholder: 'Location',
    optionValue: 'value',
    optionLabel: 'translate',
    required: true,
    onChanged: (e) => {
      this.setSelectHotelCode(e.value)
    },
    canShow: (field, value) => {
      if(this.hotelOptions?.length == 1)
        return false;
      
      if(!this.roomTypeConfig && !this.bookingInspectionData)
        return true;

      return false;
    }
  },{
    name: 'systemType',
    label: 'Select Type Of Site Tour',
    type: 'select',
    placeholder: 'Select Type Of Site Tour',
    optionValue: 'value',
    optionLabel: 'translate',
    required: true,
    onChanged: (e) => {
      this.setSelectSystemType(e.value)
    },
  }];

  checkAllowEdit() {
    return this.allowEditProfile == false ? false : true;
  }


  onShow() {
    this.getProfile();
    this.visible = true;
    this.currentHotelCode = this.hotelOptions?.length == 1 ? this.hotelOptions[0].hotelRefID : '';
    if(this.hotelOptions?.length) {
      this.systemTypeForm?.setSelectOptions('hotelCode', this.hotelOptions.map(hotel => ({value: hotel.hotelRefID, translate: hotel.hotelName})));
      if(this.searchAvailabilityQuery?.property){
        const selectProp = this.hotelOptions.findIndex(item => item.hotelRefID == this.searchAvailabilityQuery?.property);
        if(selectProp !== -1){
          this.currentHotelCode = this.searchAvailabilityQuery?.property;
        }
      } else {
        this.currentHotelCode = this.hotelOptions[0].hotelRefID;
      }
    }
    // const { firstDay, lastDay } = this.getDataDate(this.currentMonthYear.month, this.currentMonthYear.year);
    // this.readRentalItemTypeRateAvailability(firstDay, lastDay);
    this.disableDate = this.getDaysInMonth(this.currentMonthYear.month, this.currentMonthYear.year);
    this.readSystemTypesByActivityType()
    this.visibleChange.emit(this.visible);
  }

  onHide() {
    this.resetTimeSelect();
    this.visible = false;
    this.systemTypeForm?.reset();
    this.visibleChange.emit(this.visible);
  }

  onVisibleChange(visible: boolean) {
    this.visible = visible;
    this.visibleChange.emit(visible);
  }

  getProfile() {
    if (!this.auth.isLoggedIn()) {
      this.allowEditProfile = true;
      this.setField();
      this.initDataForm({});
      return;
    }
    if (!this.profileContactDetail) {
      this.btrBookingService.getProfileContact().subscribe(res => {
        if (res.success) {
          this.profileContactDetail = res.profileContactDetail;
          this.allowEditProfile = false;
          const data = res.profileContactDetail as BtrProfileAndContactDetail
          this.setField();
          this.initDataForm(data);
        }
      })
    } else {
      this.allowEditProfile = false;
      this.setField();
      this.initDataForm(this.profileContactDetail);
    }

  }

  initDataForm(data: BtrProfileAndContactDetail) {
    const { fromDate } = this.searchAvailabilityQuery || { fromDate: undefined };
    const roomData = this.bookingInspectionData?.bookInspectionRoom;
    const roomType = this.bookingInspectionData?.bookInspectionRoomType;
    const maxRate = roomData?.ratePlans[roomData?.ratePlans.length - 1];

    const profileData: BookingInspectForm = {
      firstName: data.firstName || '',
      lastName: data.lastName || '',
      email: data.emailAddressHome || '',
      phoneNumber: data.mobile?.includes('+') ? data.mobile : ((data.phoneMobileExt || '') + (data.mobile || '')),
      minBedrooms: roomType ? roomType.numberOfBedrooms.toString() : '',
      preferedMoveInDate: fromDate ? local_to_utc(fromDate) : '',
    }

    if(maxRate && maxRate.roomRate && maxRate.roomRate.amount > 0) {
      profileData.budgetAmount = maxRate.roomRate.amount.toFixed(2).toString();
    }

    if (this.inspectForm) {
      this.inspectForm.populate(profileData)
    }
  }

  loadSearchAvailabilityQuery(params: any) {
    this.searchAvailabilityQuery = this.btrBookingService.parseSearchAvailabitity(params);

    if (this.searchAvailabilityQuery) {
      this.data.stayWith = this.searchAvailabilityQuery.whoMovingIn || '';
    }
  }

  getDaysInMonth(month: number, year: number) {
    var date = local_to_utc(new Date(year, month - 1, 1));
    var days = [];

    while (date.getMonth() + 1 === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  }

  readSystemTypesByActivityType() {
    if (this.isNeedInspectionData == false && !this.currentHotelCode)
      return;

    if (this.isNeedInspectionData == true && !this.searchAvailabilityQuery) 
      return;

    const hotelRef = this.isNeedInspectionData == false ? this.currentHotelCode : this.searchAvailabilityQuery?.property;

    this.btrBookingService.readSystemTypesByActivityType(hotelRef || '').subscribe(res => {
      if (res.success && res.systemTypesByActivityTypeModels.length) {
        this.systemTypes = [...res.systemTypesByActivityTypeModels.sort((a, b) => a.sortOrder - b.sortOrder)];
        const systemType = res.systemTypesByActivityTypeModels.map(item => ({ value: item.code, translate: item.name }))
        this.systemTypeForm?.setSelectOptions('systemType', systemType)
        if(this.systemTypes.length){
          this.systemTypeForm?.populate({ systemType: this.systemTypes[0].code, hotelCode: hotelRef });
          this.setSelectSystemType(this.systemTypes[0].code)
        } else {
          this.systemTypeForm?.populate({ hotelCode: hotelRef, systemType: '' });
        }
      }
    })
    const { firstDay, lastDay } = this.getDataDate(this.currentMonthYear.month, this.currentMonthYear.year);
    this.disableDate = this.getDaysInMonth(firstDay.getMonth() + 1, lastDay.getFullYear())
  }

  readRentalItemTypeRateAvailability(arrivalDate: Date, departureDate: Date) {
    const data: ReadRentalItemTypeRateAvailabilityRQ = this.getRentalModel(arrivalDate, departureDate)
    this.btrBookingService.readRentalItemTypeRateAvailability(data).subscribe(res => {
      if (res && res.systemTimeSlots.length) {
        this.timeSlotConfigures = res.systemTimeSlots.filter(slot => slot.systemTypeCode == this.data.systemType);

        // Reset
        this.data.visitDate = '';
        this.data.timeSelect = undefined;
        this.data.timeSlotConfigure = undefined;

        this.disableDate = this.timeSlotConfigures.length ? this.checkDisableDate(this.timeSlotConfigures) : this.getDaysInMonth(arrivalDate.getMonth() + 1, arrivalDate.getFullYear());
        
      } else {
        this.disableDate = this.getDaysInMonth(arrivalDate.getMonth() + 1, arrivalDate.getFullYear())
        this.data.visitDate = '';
        this.data.timeSelect = undefined;
        this.data.timeSlotConfigure = undefined;
      }
    })
  }

  checkDisableDate(timeSlotConfigures: TimeSlotConfigure[]) {
    const timeSlots = [...timeSlotConfigures];

    const allDates = timeSlots.flatMap(slot => slot.dates);

    let disableDate = allDates.filter(slot => !slot.isAvailable).map(item => new Date(item.date));

    let availableTime: TimeSlot[] = [];
    const currentTime = new Date();

    this.timeSlotConfigures?.forEach((timeSlot) => {
      availableTime = availableTime.concat(...timeSlot.dates.find(item => this.areDatesEqual(item.date, currentTime))?.times || []).filter(time => time.fromHour > currentTime.getHours())
    });

    if (!availableTime.length) {
       disableDate.push(currentTime);
    }

    const disableDateStr = disableDate.map(e => format_date(e, 'YYYY-MM-DD'));
    const availDates = [...allDates].sort((a, b) => (new Date(a.date)).getTime() - (new Date(b.date)).getTime()).filter(e => {
      if(!e.isAvailable){
        return false;
      }
      return !disableDateStr.includes(format_date(e.date, 'YYYY-MM-DD'));
    }).map(e => new Date(e.date));

    if(availDates && availDates.length){
      const minAvailableDate = availDates[0];
      this.log.log(`minAvailableDate=${format_date(minAvailableDate, 'YYYY-MM-DD')}`);
      this.selectDate = minAvailableDate;

      // Reload time slot
      this.onDateChange(minAvailableDate);
    }
    
    return disableDate;
  }

  getHeader() {
    return this.currentStep == 'selectTime' ? this.translate.instant('label.book-a-tour.lock-in-time') : this.translate.instant('label.book-a-tour.header');
  }

  submit() {
    this.isSubmitted = true;
    if (this.inspectForm?.isValid() && this.data.visitDate) {
      this.getData();
      const data = this.getSaveSiteTourModel();
      this.btrBookingService.saveBookingInspection(data).subscribe(res => {
        if (res.success) {
          this.btrBookingService.saveSendUtmLocal('siteTour');
          const { firstDay, lastDay } = this.getDataDate(this.currentMonthYear.month, this.currentMonthYear.year);
          this.readRentalItemTypeRateAvailability(firstDay, lastDay);
          this.resetForm();
          this.inspectForm?.reset();
          this.isSubmitted = false;
          if(!this.auth.isLoggedIn()){
            this.googleEventTrigger('register_success', 'BookSiteTour');
          }

          if(data.propertyCode){
            this.btrBookingService.readHotelContactInformation(data.propertyCode).subscribe(contact => {
              this.showSuccessMessage(contact);
            });
          }
          else{
            this.showSuccessMessage();
          }          
        } else {
          const error = res.errors.find(item => item.code == 'BS0331');
          this.isSubmitted = false;
          if (res.errors.length && error) {
            this.resetTimeSelect();
            const { firstDay, lastDay } = this.getDataDate(this.currentMonthYear.month, this.currentMonthYear.year);
            this.readRentalItemTypeRateAvailability(firstDay, lastDay);
          }
        }
      })
    } else {
      this.ui.toastErrorT('form.error.complete-required-field')
    }
  }

  showSuccessMessage(contact?: ApiReadHotelContactInformationRS){
    let params: any = {};
    if(contact){
      if(contact.emailAddress){
        params.email = contact.emailAddress;
      }
      if(contact.phoneNumber){
        params.phoneDisplay = `${/^\s*\+/.test(contact.phoneNumber) ? '' : `${contact.phoneNumberExt}`}${contact.phoneNumber}`;
        params.phone = params.phoneDisplay.replace(/[\(\)\s]/ig, '');
      }
    }

    this.translate.get(['msg.book-sitetour-success-title', 'msg.book-sitetour-success'], params).subscribe((text) => {
      this.confirmationService.confirm({
        message: (text['msg.book-sitetour-success'] as string).replace('{{residentPortalSiteURL}}', this.config.residentPortalSiteURL),
        header: text['msg.book-sitetour-success-title'],
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'OK',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.onSubmit.next(null);
        },
        reject: () => {
          this.onSubmit.next(null);
        },
        rejectVisible: false
      });
    });
  }

  resetTimeSelect() {
    this.currentStep = 'selectTime';
    this.data.visitDate = '';
    this.data.timeSelect = undefined;
    this.calendar?.clear();
  }

  resetForm() {
    this.currentStep = 'selectTime';
    this.timeSlotConfigure = undefined;
    this.data = {
      siteTourBookingID: '',
      systemType: '',
      propertyCode: '',
      hotelRoomTypeID: 0,
      hotelRoomID: 0,
      visitDate: '',
      timeSelect: undefined,
      timeSlotConfigure: undefined,
      stayWith: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      phoneExt: '',
      budgetType: 'Weekly',
      budgetAmount: '',
      location: '',
      isKeepUpdate: false,
      furniture: '',
      siteTourType: '',
      pet: false,
      parking: false,
      remark: '',
      preferedMoveInDate: '',
      minBedrooms: ''
    }
  }

  getData() {
    const inspectFormData = this.inspectForm?.getData() as BookingInspectForm;
    const visitDate = new Date(this.data.visitDate)
    const date = new Date(Date.UTC(visitDate.getFullYear(), visitDate.getMonth(), visitDate.getDate()));
    const hotelRef = this.isNeedInspectionData == false ? this.currentHotelCode : this.searchAvailabilityQuery?.property;

    this.data.visitDate = date;
    this.data.propertyCode = hotelRef || '';
    this.data.hotelRoomTypeID = this.bookingInspectionData?.bookInspectionRoomType?.roomTypeID || 0;
    this.data.hotelRoomID = this.bookingInspectionData?.bookInspectionRoom?.hotelRoomID || 0;
    this.data.firstName = inspectFormData.firstName;
    this.data.lastName = inspectFormData.lastName;
    this.data.email = inspectFormData.email;
    this.data.phoneNumber = inspectFormData.phoneNumber;
    this.data.phoneExt = inspectFormData.phoneNumberDialCode || '';
    this.data.budgetAmount = inspectFormData.budgetAmount || '';
    this.data.furniture = inspectFormData.furnished || 'Either';
    this.data.siteTourType = 'OnSite';
    this.data.pet = inspectFormData.isHavePet || false;
    this.data.parking = inspectFormData.isParking || false;
    this.data.remark = inspectFormData.remark || '';
    this.data.stayWith = inspectFormData.stayWith || '';
    this.data.minBedrooms = inspectFormData.minBedrooms || '';

    if(inspectFormData.preferedMoveInDate){
      const preferDate = new Date(inspectFormData.preferedMoveInDate)
      this.data.preferedMoveInDate = new Date(Date.UTC(preferDate.getFullYear(), preferDate.getMonth(), preferDate.getDate()));
    } else {
      delete this.data.preferedMoveInDate;
    }
  }

  getSaveSiteTourModel() {
    const data: any = {};
    const hotelRef = this.isNeedInspectionData == false ? this.currentHotelCode : this.searchAvailabilityQuery?.property;

    data.rentalItemTypeRateAvailabilityModel = this.getRentalModel(this.data.visitDate, this.data.visitDate);
    data.bookInspectionModel = { ...this.data, timeSelect: undefined, timeSlotConfigure: undefined };
    data.propertyCode = hotelRef || '';
    // data.propertyCode = 'KA';
    data.distributionChannelCode = this.config.apiServer.distributionChannelCode;
    data.timeSlotID = this.data.timeSlotConfigure?.systemTimeSlotID;
    data.timeSlotActivityType = "System";
    data.timeSlotActivityItemType = "SiteTour";
    // data.hotelRoomTypeID = this.bookingInspectionData?.bookInspectionRoomType?.roomTypeID || '';
    data.systemTypeID = this.data.timeSlotConfigure?.systemTypeID || '';
    data.rentalAllotmentID = this.data.timeSelect?.allotmentID || '';
    data.rentalItemBookingID = '';

    data.RentalItemBookingItemModels = [{
      bookDate: this.data.visitDate,
      fromHour: this.data.timeSelect?.fromHour,
      fromMinute: this.data.timeSelect?.fromMinute,
      toHour: this.data.timeSelect?.toHour,
      toMinute: this.data.timeSelect?.toMinute,
      timeSlotItemID: this.data.timeSelect?.timeSlotItemID,
      rentalAllotmentItemGenerateID: this.data.timeSelect?.allotmentItemGenerateIDs ? this.data.timeSelect?.allotmentItemGenerateIDs[0]?.toString() : undefined,
      systemTimeSlotID: this.data.timeSlotConfigure?.systemTimeSlotID
    }]

    //utm info
    data.utmInfo = this.btrBookingService.getUtmContent('siteTour') || undefined;
    return data;
  }

  getRentalModel(arrivalDate: Date | string, departureDate: Date | string) {
    const hotelRef = this.isNeedInspectionData == false ? this.currentHotelCode : this.searchAvailabilityQuery?.property;

    const data: ReadRentalItemTypeRateAvailabilityRQ = {
      distributionChannelCodes: [
        this.config.apiServer.distributionChannelCode
      ],
      hotelCode: hotelRef || '',
      // hotelCode: 'KA',
      rentalItemTypeCodes: [],
      arrivalDate: new Date(arrivalDate),
      departureDate: new Date(departureDate),
      timeSlotActivityTypes: [
        "System"
      ],
      timeSlotActivityItemTypes: [
        "SiteTour"
      ],
      roomTypeCodes: [],
      bookingConditionPersonTypes: [],
      isGetSystemStimeSlotOnly: true,
      filterOption: {
        isIgnoreRentalItemTypesForNonResidentAtt: true,
        isIgnoreRoomTypeItemsAtt: true,
        isIgnoreSystemTimeSlotsAtt: false
      }
    }
    return data
  }

  setSelectHotelCode(hotelCode: string) {
    this.currentHotelCode = hotelCode;
    this.readSystemTypesByActivityType();
  }

  setSelectSystemType(type: string) {
    if(!type) {
      return;
    }

    this.data.systemType = type;
    this.systemTypeDescription = this.systemTypes.find(e => e.code == type)?.description || '';
    this.resetTimeSelect();
    const { firstDay, lastDay } = this.getDataDate(this.currentMonthYear.month, this.currentMonthYear.year);
    this.readRentalItemTypeRateAvailability(firstDay, lastDay);
  }

  checkValid() {
    return (this.inspectForm?.isValid() && this.data.visitDate);
  }

  getCurrentDate() {
    return this.currentDate;
  }

  formatDate(date: Date | string) {
    if (!date) {
      return '';
    }
    const newDate = new Date(date);
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    };
    const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat('en-US', options);
    const formattedDate: string = formatter.format(newDate);
    return formattedDate
  }

  selectTime(time: TimeSlot, timeSlot: TimeSlotConfigure) {
    this.data.timeSelect = time
    this.data.timeSlotConfigure = timeSlot
  }

  nextStep() {
    this.currentStep = 'fillData';
    this.isSubmitted = true;
    if(!this.auth.isLoggedIn()){
      this.googleEventTrigger('register_form', 'BookSiteTour');
    }
    setTimeout(() => this.setFormOption(), 0);
  }

  previousStep() {
    this.currentStep = 'selectTime';
  }

  onDateChange(e: any) {
    this.data.visitDate = local_to_utc(e);
    this.data.timeSelect = undefined;
    this.availableTime = this.timeSlotConfigure?.dates.find(item => local_to_utc(item.date).toString() == local_to_utc(e).toString())?.times
      .filter(time => time.isAvailable) || [];
  }

  onMonthChange(e: any) {
    const { firstDay, lastDay } = this.getDataDate(e.month, e.year)
    this.currentMonthYear = { month: e.month, year: e.year }
    this.resetTimeSelect();
    this.readRentalItemTypeRateAvailability(firstDay, lastDay);
  }

  getDataDate(month?: number, year?: number) {
    if (!month || !year) {
      const currentDate = new Date();
      month = currentDate.getMonth() + 1;
      year = currentDate.getFullYear();
    }

    const date = new Date(year, month - 1, 1);
    const isCurrentMonth = month === new Date().getMonth() + 1;
    const firstDay = isCurrentMonth ? new Date() : new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = isCurrentMonth ? new Date(date.getFullYear(), date.getMonth() + 1, 0) : new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return {
      firstDay: local_to_utc(firstDay),
      lastDay: local_to_utc(lastDay)
    };
  }

  formatTime(timeStr: string): string {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const period: string = hours < 12 ? 'am' : 'pm';
    const formattedHours: number = hours % 12 !== 0 ? hours % 12 : 12;
    const formattedTime: string = `${formattedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;
    return formattedTime;
  }

  getAvailableTime(code: string, type: string) {
    const selectDate = this.data.visitDate;
    const currentTime = new Date();
    let availableTime = this.timeSlotConfigures?.find(item => item.code == code)?.dates.find(item => local_to_utc(item.date).toString() == selectDate.toString())?.times.filter(time => time.isAvailable)
    
    if(!availableTime)
      return []

    if(this.areDatesEqual(currentTime, new Date(selectDate))){
      availableTime = availableTime.filter(time  => time.fromHour > currentTime.getHours());
    }

    if (type === 'morning') {  
      return availableTime && availableTime.length ? availableTime.filter(time => time.fromHour < 12) : [];
    } else if (type === 'afternoon') {
      return availableTime && availableTime.length ? availableTime.filter(time => time.fromHour >= 12 && time.fromHour < 18) : [];
    } else if (type === 'evening') {
      return availableTime && availableTime.length ? availableTime.filter(time => time.fromHour >= 18) : [];
    }
    return [];
  }

  getIconForDate(checkDate: { day: number, month: number, year: number }) {
    let { day, month, year } = checkDate;
    if (this.disableDate.some(date => this.areDatesEqual(date, new Date(year, month, day)))) {
      return []
    } else {
      const arrayIcon = [];
      let availableTime: TimeSlot[] = [];

      this.timeSlotConfigures?.forEach((timeSlot) => {
        availableTime = availableTime.concat(...timeSlot.dates.find(item => this.areDatesEqual(item.date, new Date(year, month, day)))?.times || [])
      });

      const currentTime = new Date(); 

      //allow date.fromDate > currentHour
      if(this.areDatesEqual(currentTime, new Date(year, month, day))){
        availableTime = availableTime.filter(time  => time.fromHour > currentTime.getHours());
      }

      if (!availableTime) {
        return []
      }
      //0am - 11:59am
      if (availableTime.some(time => time.fromHour < 12 && time.isAvailable == true)) {
        arrayIcon.push('morning')
      }
      //12pm - 17:59pm
      if (availableTime.some(time => time.fromHour >= 12 && time.fromHour < 18 && time.isAvailable == true)) {
        arrayIcon.push('afternoon')
      }
      //18pm - 23:59pm
      if (availableTime.some(time => time.fromHour >= 18 && time.isAvailable == true)) {
        arrayIcon.push('evening')
      }
      return arrayIcon;
    }
  }

  areDatesEqual(date1: Date, date2: Date): boolean {
    return (
      local_to_utc(date1).toString() === local_to_utc(date2).toString()
    );
  }

  setFormOption() {
    const furnishedType = this.btrBookingService.getFurnishedData();
    const siteTourType = this.btrBookingService.getSiteTourTypeData();
    const stayWithType = this.btrBookingService.getStayWithData();
    const minBedrooms = this.btrBookingService.getMinBedRoomData();

    this.inspectForm?.setSelectOptions('furnished', furnishedType);
    this.inspectForm?.setSelectOptions('siteTourType', siteTourType);
    this.inspectForm?.setSelectOptions('stayWith', stayWithType);
    this.inspectForm?.setSelectOptions('minBedrooms', minBedrooms);

  }

  getDescriptionTimeSelect(timeSelect: TimeSlot | undefined) {
    if (timeSelect){
      const time = timeSelect.description ? timeSelect.description : `${timeSelect.fromTimeDisplay} - ${timeSelect.toTimeDisplay}`;
      return time.toLowerCase();
    }
    return '';
  }

  setField() {
    this.fields = [{
      name: 'row1',
      type: 'row',
      columns: [{
        name: 'firstName',
        label: 'First Name',
        placeholder: 'First Name',
        required: true,
        readonly: !this.checkAllowEdit()
      }, {
        name: 'lastName',
        label: 'Last Name',
        placeholder: 'Last Name',
        required: true,
        readonly: !this.checkAllowEdit()
      }]
    }, {
      name: 'row2',
      type: 'row',
      columns: [{
        name: 'phoneNumber',
        label: 'Mobile',
        placeholder: 'Mobile',
        type: 'phone',
        required: true,
        readonly: !this.checkAllowEdit()
      }, {
        name: 'email',
        label: 'Email',
        placeholder: 'abc@gmail.com',
        type: 'email',
        required: true,
        readonly: !this.checkAllowEdit()
      }]
    }, {
      name: 'row3',
      type: 'row',
      columns: [{
        name: 'preferedMoveInDate',
        label: 'Preferred Move in Date',
        placeholder: 'Preferred Move in Date',
        type: 'date',
        dateFormat: 'dd/mm/yy',
        calendarView: 'date',
        minDate: new Date()
      }, {
        name: 'budgetAmount',
        label: 'Maximum rent per week​',
        placeholder: 'Maximum rent per week​',
        customValidateError: (value: string) => {
          const numericValue = Number(value);
          if (!isNaN(numericValue)) {
            return '';
          }
          return 'form.error.invalid-field';
        },
        required: true,
      }, ]
    }, {
      name: 'row4',
      type: 'row',
      columns: [{
        name: 'minBedrooms',
        label: 'Min Bedrooms',
        placeholder: 'Min Bedrooms',
        type: 'select',
        optionValue: 'value',
        optionLabel: 'translate',
        required: true
      }, {
        name: 'furnished',
        label: 'Looking for a furnished apartment',
        placeholder: 'Looking for a furnished apartment',
        type: 'select',
        optionValue: 'value',
        optionLabel: 'translate',
      }]
    }, {
      name: 'row5',
      type: 'row',
      columns: [{
        name: 'stayWith',
        label: 'Who’s moving in?',
        placeholder: 'Who’s moving in?',
        type: 'select',
        optionValue: 'value',
        optionLabel: 'translate',
        required: true
      }, {
        name: 'remark',
        label: 'Anything else we should know?​',
        placeholder: 'Anything else we should know?​',
      }]
    }, {
      name: 'row5',
      type: 'row',
      columns: [{
        name: 'isHavePet',
        label: 'I have a pet',
        type: 'switch',
      }, {
        name: 'isParking',
        label: 'I need parking',
        type: 'switch',
      }]
    },]
  }

  getSrcIconImage(icon: string){
    return `assets/images/${icon}.svg`
  }

  getHotelSelectName() {
    const select = this.systemTypeForm?.getSelectedOption('hotelCode');
    return select ? select.translate : '';
  }

  googleEventTrigger(event: GgEventName, action: GgEventAction) {
    ((window as any).dataLayer || []).push({
      'event': event,
      'action': action,
    });
  }

}
